import { z } from 'zod';
import { ParticipantSchema } from '../projects/ProjectFormData';
import { MarginRateSchema } from '../common/margin-rate.schema';

export const EstimateParticipantSchema = ParticipantSchema.extend({
  isSelected: z.boolean().default(true),
});

export type EstimateParticipantFormData = z.infer<
  typeof EstimateParticipantSchema
>;

const FlexibilityEnum = z.enum(['true', 'false']);

export const CreateEstimateSchema = z.object({
  marginRate: MarginRateSchema.optional(),
  name: z.string().optional(),
  allowAgencyModification: FlexibilityEnum.optional().default('false'),
  showQuoteName: FlexibilityEnum.optional().default('true'),
  showSummaryAndImportantPoints: FlexibilityEnum.optional().default('true'),
  showPriceIncludesExcludes: FlexibilityEnum.optional().default('true'),
  showModificationCancellationConditions:
    FlexibilityEnum.optional().default('true'),
  showDates: FlexibilityEnum.optional().default('true'),
  allowAgencyInternationalFlights: FlexibilityEnum.optional().default('false'),
  allowAgencyMarginRate: FlexibilityEnum.optional().default('false'),
  allowAgencyAdditionalMargin: FlexibilityEnum.optional().default('false'),
  adults: z
    .array(EstimateParticipantSchema)
    .min(1, { message: 'Au moins un adulte est requis' })
    .refine((adults) => adults.some((a) => a.isSelected), {
      message: 'Au moins un adulte est requis',
    }),
  children: z
    .array(EstimateParticipantSchema)
    .refine(
      (children) => children.every(({ birthDate }) => birthDate != undefined),
      { message: 'La date de naissance est obligatoire' },
    ),
});

export type CreateEstimateFormData = z.infer<typeof CreateEstimateSchema>;
